<template>
  <div class="meal-generator">

    <div class="content">
      <mu-content-block>
        <h1 style="margin-top: 8px">Meal plan generator</h1>
        <p style="margin-top: 8px; margin-bottom: 24px">Generate a meal plan from hundreds of delicious recipes in our
          database.</p>
      </mu-content-block>
    </div>

    <div class="content" v-if="!isMealPlanShown">
      <mu-card>
        <mu-card-text>

          <meal-plan-filter-modal
            style="margin-bottom: 24px;"
            @change="filtersSet">
          </meal-plan-filter-modal>

          <div class="mu-text-field-label">Which days do you want to plan for</div>
          <mu-float-button
            style="margin: 4px"
            mini
            class="day-button outline"
            v-for="(day, index) in model.days"
            :key="'day-' + index"
            :class="{'active': model.availableDays.includes(day.name)}"
            @click.native="addToAvailableDays(day.name)">
            {{day.label}}
          </mu-float-button>

          <div class="mu-text-field-label" style="margin-top: 16px;margin-bottom: 8px;">
            Which meals do you want to plan for?
          </div>

          <div class="bottom">
            <mu-raised-button
              class="align-icon-right"
              full-width
              label="Breakfast"
              label-position="before"
              icon="radio_button_unchecked"
              @click="toggleMeal('BREAKFAST')"
              :icon="model.availableMeals.includes('BREAKFAST') ? 'radio_button_checked' : 'radio_button_unchecked'"
            >

            </mu-raised-button>

          </div>
          <div class="bottom">
            <mu-raised-button
              class="align-icon-right"
              full-width
              label="Lunch"
              label-position="before"
              icon="radio_button_unchecked" @click="toggleMeal('LUNCH')"
              :icon="model.availableMeals.includes('LUNCH') ? 'radio_button_checked' : 'radio_button_unchecked'"
            ></mu-raised-button>
          </div>
          <div class="bottom">
            <mu-raised-button
              class="align-icon-right"
              full-width
              label="Dinner"
              label-position="before"
              :icon="model.availableMeals.includes('DINNER') ? 'radio_button_checked' : 'radio_button_unchecked'"
              @click="toggleMeal('DINNER')"></mu-raised-button>
          </div>


          <div class="mu-text-field-label" style="margin-top: 18px;">
            How many people are you planning for?
          </div>

          <mu-row style="margin-top: 8px">
            <mu-col align="left" width="15">
              <mu-float-button
                class="incrementor-btn"
                mini
                @click.native="decrementServings">
                <mu-icon value="remove_circle_outline"></mu-icon>
              </mu-float-button>
            </mu-col>
            <mu-col align="center" width="70">
              <img style="margin: 8px;" v-for="(item, sin) in model.servingslte" :key="'serving-' + sin" src="static/ic_male.png"/>
            </mu-col>
            <mu-col align="right" width="15">
              <mu-float-button
                class="incrementor-btn"
                mini
                @click.native="incrementServings"
              >
                <mu-icon value="add_circle_outline"></mu-icon>
              </mu-float-button>
            </mu-col>
          </mu-row>

          <mu-row style="margin-top: 16px; margin-bottom: 24px">
            <mu-col align="left" width="33"></mu-col>
            <mu-col align="center" width="33">{{model.servingslte}} people</mu-col>
            <mu-col align="right" width="33"></mu-col>
          </mu-row>

          <mu-raised-button
            full-width
            secondary
            label="Create plan"
            @click.native="generateMealPlans">
          </mu-raised-button>
        </mu-card-text>
      </mu-card>

    </div>


    <div v-if="isMealPlanShown" class="content">
      <div style="display: flex; justify-content: left; margin-bottom: 24px;">
        <div style="display: flex; align-self: center">
          <mu-float-button
            style="margin: 2px;"
            mini
            label="M"
            v-for="(day, dayIndex) in model.days"
            :key="'shown-day-' + dayIndex"
            :class="{'activeDay': day.name === activeDay, 'faded': !daySatisfied(day)}"
            v-if="model.availableDays.includes(day.name)"

            class="day-button"
            @click.native="setDay(day.name)">
            {{day.label}}
          </mu-float-button>
        </div>
      </div>
      <div class="content" style="margin-bottom: 24px;">


        <mu-row>
          <mu-col>
            <meal-plan-filter-modal></meal-plan-filter-modal>
          </mu-col>
          <mu-col>

          </mu-col>
        </mu-row>

      </div>

      <meal-plan-panel
        v-if="model.availableMeals.includes('BREAKFAST')"
        :allergies="allergyCsv"
        :filters="filters"
        :dietaryTypes="dietaryTypesList().join(',')"
        :activeDay="activeDay"
        type="breakfast"
        :recipe="activeBreakfastForDay"
        @changed="pushToBreakfast">
      </meal-plan-panel>

      <meal-plan-panel
        v-if="model.availableMeals.includes('LUNCH')"
        :allergies="allergyCsv"
        :filters="filters"
        :dietaryTypes="dietaryTypesList().join(',')"
        :activeDay="activeDay"
        type="lunch"
        :recipe="activeLunchForDay"
        @changed="pushToLunch">
      </meal-plan-panel>

      <meal-plan-panel
        v-if="model.availableMeals.includes('DINNER')"
        :allergies="allergyCsv"
        :filters="filters"
        :dietaryTypes="dietaryTypesList().join(',')"
        :activeDay="activeDay"
        type="dinner"
        :recipe="activeDinnerForDay"
        @changed="pushToDinner">
      </meal-plan-panel>

      <div class="content" align="center">
        <mu-raised-button
          :disabled="!satisfiedDays"
          @click.native="openMealPlanModal"
          label="Create plan">
        </mu-raised-button>
      </div>


      <mu-dialog :open="dialogOpen" title="Give your meal plan a name" @close="dialogOpen = false">
        <form @submit.prevent="saveMealPlan">
          <mu-text-field
            v-model="model.name"
            full-width
            label="Name"
            hint-text="Enter a name for your meal plan">
          </mu-text-field>
          <div align="right">
            <mu-flat-button slot="actions" @click="dialogOpen = false" primary :label="$t('message.cancelText')"/>
            <button type="submit" style="display: none"></button>
            <mu-raised-button
              type="button"
              @click.native="saveMealPlan"
              slot="actions"
              primary
              @click="dialogOpen = false"
              :label="$t('message.okText')"
            />
          </div>
        </form>
      </mu-dialog>
    </div>
  </div>
</template>

<script>

  import AccountApi from '../../../api/Account'
  import RecipeApi from '../../../api/Recipes'

  import axios from 'axios'

  import MealPlanPanel from "./components/meal-plan-panel";
  import MuFloatButton from "muse-ui/src/floatButton/floatButton";
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  import MuTextField from "muse-ui/src/textField/textField";
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";
  import MealPlanFilterModal from "./components/meal-plan-filter-modal";

  export default {
    components: {
      MealPlanFilterModal,
      MuCircularProgress,
      MuTextField,
      MuRaisedButton,
      MuFloatButton,
      MealPlanPanel
    },
    name: "meaplan-generator-index",
    data() {
      return {
        isMealPlanShown: false,
        dialogOpen: false,
        dietaryPreferenceId: 0,
        activeDay: 'MONDAY',
        allergyCsv: "",
        listener: 0,
        filters: {},
        model: {
          name: null,
          servingslte: 1,
          servings: 0,
          availableMeals: [
            'BREAKFAST',
            'LUNCH',
            'DINNER'
          ],
          availableDays: [
            'MONDAY',
            'TUESDAY',
            'WEDNESDAY',
            'THURSDAY',
            'FRIDAY',
            'SATURDAY',
            'SUNDAY'
          ],
          days: [
            {
              label: 'M',
              name: 'MONDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            },
            {
              label: 'T',
              name: 'TUESDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            },
            {
              label: 'W',
              name: 'WEDNESDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            },
            {
              label: 'T',
              name: 'THURSDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            },
            {
              label: 'F',
              name: 'FRIDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            },
            {
              label: 'S',
              name: 'SATURDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            },
            {
              label: 'S',
              name: 'SUNDAY',
              breakfast: [],
              lunch: [],
              dinner: []
            }
          ]
        }
      }
    },

    methods: {
      filtersSet(data) {
        this.filters = data;
      },
      daySatisfied(day) {
        let self = this;
        let mealsForThisDayCount = self.model.availableMeals.length;
        let mealsChecked = 0;
        self.model.availableMeals.forEach(function (item) {
          if (day[item.toLowerCase()].length > 0) {
            mealsChecked++;
          }
        });
        return mealsChecked === mealsForThisDayCount;
      },
      toggleMeal(meal) {
        let self = this;
        if (self.model.availableMeals.includes(meal)) {
          let index = self.model.availableMeals.indexOf(meal);
          self.model.availableMeals.splice(index, 1);
        }
        else {
          self.model.availableMeals.push(meal);
        }
        const meals = [
          'BREAKFAST',
          'LUNCH',
          'DINNER'
        ];
        const sortMeals = function (a, b) {
          a = meals.indexOf(a);
          b = meals.indexOf(b);
          return a < b ? 0 : 1;
        };
        self.model.availableMeals = self.model.availableMeals.sort(sortMeals);
        self.$forceUpdate();
      },
      saveMealPlan() {
        let self = this;

        self.model.servings = self.model.servingslte;

        if (self.model.name === null || self.model.name === "") {
          self.$alert({
            title: "Error!",
            text: "Must give your meal plan a name",
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "white"
          });
        }
        else {
          RecipeApi.addMealPlan(self.model)
            .then(function (response) {
              self.$router.push({
                name: 'MealPlanDetail',
                params: {
                  id: response.data.id
                }
              })
            });
        }


      },
      openMealPlanModal() {
        this.dialogOpen = true;
      },
      generateMealPlans() {


        let token =  axios.CancelToken;

        RecipeApi.CancelToken = token;

        let self = this;

        if (self.model.availableMeals.length === 0) {
          self.$alert({
            title: "Error!",
            text: "Select at least one meal type",
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "white"
          });
        }

        if (self.model.availableDays.length === 0) {
          self.$alert({
            title: "Error!",
            text: "Select at least one day of the week",
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "white"
          });
        }

        if (self.model.availableMeals.length > 0 && self.model.availableDays.length > 0) {

          self.lists = self.$store.state.list;
          let allergies = self.lists.allergies;

          self.activeDay = self.model.availableDays[0];
          AccountApi.getUserPersonalization()
            .then(function (response) {


                self.dietaryPreferenceId = response.data.dietry_preference_id;
                let allergyStrings = [];
                if (response.data.allergies.length > 0) {
                  for (let i = 0; i < response.data.allergies.length; i++) {
                    let foundAllergy = allergies.filter(function (item) {
                      return item.allergy_id === response.data.allergies[i];
                    });

                    if (foundAllergy.length > 0) {
                      allergyStrings.push(foundAllergy[0].name);
                    }
                  }
                  self.allergyCsv = allergyStrings.join(',');
                }

                let allergyObj = {
                  suitabilities: self.allergyCsv
                };

                self.dietaryPreferenceId = response.data.dietry_preference_id;
                self.isMealPlanShown = true;
                let model = self.model;
                model.days.forEach(function (item, index) {
                  if (self.model.availableDays.includes(item.name)) {

                    if (self.model.availableMeals.includes('BREAKFAST')) {
                      let filter = self.filters;
                      let breakfastObject = {
                        servingslte: self.model.servingslte,
                        categories: 'Breakfast',
                        suitabilities: allergyStrings.join(','),
                        dietaryTypes: self.dietaryTypesList().join(','),
                        limit: 1,
                        shuffle: true
                      };
                      let bObj = Object.assign(breakfastObject, filter);
                      RecipeApi.CancelToken = token;
                      RecipeApi.search(bObj)
                        .then(function (response) {

                          let data = response.data.recipes[0];
                          let self = this;
                          let currentDay = model.days.filter(function (e) {
                            return e.name === item.name;
                          });
                          let day = currentDay[0];
                          day.breakfast = [];
                          day.breakfast.push(data);
                          self.listener = index;
                          if (index === 0) {
                            self.activeDay = self.sorted[1];
                            self.$nextTick(function () {
                              self.activeDay = self.sorted[0]
                              self.$forceUpdate();
                            })
                          }
                        }.bind(self));
                    }
                    if (self.model.availableMeals.includes('LUNCH')) {

                      let filter = self.filters;
                      let lunchObject = {
                        servingslte: self.model.servingslte,
                        categories: 'Lunch',
                        suitabilities: allergyStrings.join(','),
                        dietaryTypes: self.dietaryTypesList().join(','),
                        limit: 1,
                        shuffle: true
                      };
                      let lObj = Object.assign(lunchObject, filter);

                      RecipeApi.CancelToken = token;
                      RecipeApi.search(lObj)
                        .then(function (response) {
                          let data = response.data.recipes[0];
                          let self = this;
                          let currentDay = model.days.filter(function (e) {
                            return e.name === item.name;
                          });
                          let day = currentDay[0];
                          day.lunch = [];
                          day.lunch.push(data);
                          self.listener = index;
                          self.$nextTick(function () {
                            if (index === 0) {
                              self.activeDay = self.sorted[1]
                              self.$nextTick(function () {
                                self.activeDay = self.sorted[0]
                                self.$forceUpdate();
                              })
                            }
                            self.$forceUpdate();
                          })

                        }.bind(self));
                    }
                    if (self.model.availableMeals.includes('DINNER')) {
                      let filter = self.filters;
                      let dinnerObj = {
                        servingslte: self.model.servingslte,
                        categories: 'Dinner',
                        suitabilities: allergyStrings.join(','),
                        dietaryTypes: self.dietaryTypesList().join(','),
                        limit: 1,
                        shuffle: true
                      };

                      let dObj = Object.assign(dinnerObj, filter);


                      RecipeApi.CancelToken = token;
                      RecipeApi.search(dObj)
                        .then(function (response) {

                          let data = response.data.recipes[0];
                          let self = this;
                          let currentDay = model.days.filter(function (e) {
                            return e.name === item.name;
                          });
                          let day = currentDay[0];
                          day.dinner = [];
                          day.dinner.push(data);
                          self.listener = index;
                          if (index === 0) {
                            self.activeDay = self.sorted[1];
                            self.$nextTick(function () {
                              self.activeDay = self.sorted[0];
                              self.$forceUpdate();
                            })
                          }
                        }.bind(self));
                    }
                  }
                })
              }
            );
        }

      },
      incrementServings() {
        if(this.model.servingslte < 28) {
          this.model.servingslte++;
        }
      },
      decrementServings() {
        if (this.model.servingslte > 1) {
          this.model.servingslte--;
        }
      },
      addToAvailableDays(day) {
        let self = this;
        if (self.model.availableDays.includes(day)) {
          self.model.availableDays.splice(self.model.availableDays.indexOf(day), 1);
        }
        else {
          self.model.availableDays.push(day);
        }
      },
      dietaryTypesList() {
        let self = this;
        switch (self.dietaryPreferenceId) {
          case 1:
            return [
              'Gluten-free',
              'Iron rich',
              'Ketogenic',
              'Low GI',
              'Organic',
              'Paleolithic',
              'Pescetarian',
              'Raw Foods',
              'Vegan',
              'Vegetarian'
            ];
          case 2:
            return [
              'Pescetarian'
            ];
          case 3:
            return [
              'Vegetarian'
            ];
          case 4:
            return [
              'Vegan'
            ];
          default:
            return [
              'Gluten-free',
              'Iron rich',
              'Ketogenic',
              'Low GI',
              'Organic',
              'Paleolithic',
              'Pescetarian',
              'Raw Foods',
              'Vegan',
              'Vegetarian'
            ];
        }
      },
      pushToBreakfast(recipe) {
        let self = this;
        let currentDay = self.model.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        let day = currentDay[0];
        day.breakfast = [];
        day.breakfast.push(recipe);
      },
      pushToLunch(recipe) {
        let self = this;
        let currentDay = self.model.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        let day = currentDay[0];
        day.lunch = [];
        day.lunch.push(recipe);
      },
      pushToDinner(recipe) {
        let self = this;
        let currentDay = self.model.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        let day = currentDay[0];
        day.dinner = [];
        day.dinner.push(recipe);
      },
      setDay(day) {
        this.activeDay = day;
      }
    },
    computed: {
      satisfiedDays() {
        let self = this;
        let satisfiableCount = self.model.availableDays.length;
        let satisfiedDataStructure = [];
        self.model.availableDays
          .forEach(function (item) {
            let day = self.model.days
              .filter(function (dayItem) {
                return dayItem.name === item;
              })[0];
            let conditions = [];
            self.model.availableMeals.forEach(function (item) {
              conditions.push(day[item.toLowerCase()].length > 0);
            });
            let checkTrueAll = conditions.filter(function (e) {
              return e === true;
            });
            if (checkTrueAll.length === self.model.availableMeals.length) {
              satisfiedDataStructure.push(day);
            }
          });
        return satisfiedDataStructure.length === satisfiableCount;
      },
      sorted() {
        let self = this;
        const days = [
          'MONDAY',
          'TUESDAY',
          'WEDNESDAY',
          'THURSDAY',
          'FRIDAY',
          'SATURDAY',
          'SUNDAY'
        ];
        const sortDays = function (a, b) {
          a = days.indexOf(a);
          b = days.indexOf(b);
          return a < b ? 0 : 1;
        };
        return self.model.availableDays.sort(sortDays)
      },
      activeBreakfastForDay() {
        let self = this;
        let item = self.model.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        if (item[0].breakfast.length > 0) {
          return item[0].breakfast;
        }
        return [];
      },
      activeDinnerForDay() {
        let self = this;
        let item = self.model.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        if (item[0].dinner.length > 0) {
          return item[0].dinner;
        }
        return [];
      },
      activeLunchForDay() {
        let self = this;
        let item = self.model.days.filter(function (item) {
          return item.name === self.activeDay;
        });
        if (item[0].lunch.length > 0) {
          return item[0].lunch;
        }
        return [];
      }
    },
    beforeDestroy() {
      RecipeApi.CancelRequests();
    }
  }
</script>
<style lang="less">

  .meal-generator {
    .content {
      .mu-content-block {
        padding-left: 0;
          h1 {
            color: #0179d5;
          }
      }
    }
  }

  .faded {
    opacity: 0.6;
  }

  .mu-text-field-label {
    font-size: 16px;
  }


  button.mu-raised-button.align-icon-right .mu-raised-button-wrapper {
    align-items: initial;
    justify-content: normal;
  }

  .align-icon-right .mu-icon {
    position: absolute;
    right: 6px !important;
    top: 6px;
  }

  .align-icon-right {
    color: #0179d6 !important;
  }

  .incrementor-btn {
    color: #0179d6 !important;
    background: white !important;;
  }


  .day-button {
    background: white !important;
    color: #0179d6 !important;
  }


  .day-button.outline {
    border: 1px solid #0179d6;
    box-shadow: none;
    color: #0179d6 !important;
    background-color: white !important;

  }

  .day-button.active {
    background: #0179d6 !important;
    color: white !important;
  }

  .activeDay:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #0179d6;
    bottom: 0px;
    left: 15px;
  }

  button.mu-float-button.day-button {
    background: white;
    color: #0179d6;
    font-weight: bold;
  }

  @-moz-keyframes fadeOut {
    from {
      opacity: 1;
      visibility: visible;
    }

    to {
      opacity: 0;
      visibility: hidden;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      visibility: visible;
    }

    to {
      opacity: 0;
      visibility: hidden;
    }
  }

  .hide-card {
    animation-fill-mode: forwards;
    -webkit-animation: ease fadeOut 0.3s;
    -o-animation: ease fadeOut 0.3s;
    -moz-animation: ease fadeOut 0.3;
    animation: fadeOut;
    animation-duration: 0.3s;

  }

  .card-viewport {

    .stack {
      width: 200px;
      height: 300px;
      background: #ED5D52;
      position: relative;
      top: 0px;
      left: 50%;
      margin-left: -100px;
      border-radius: 10px;

    }

    li.card {

      animation-fill-mode: forwards;
      background-repeat: no-repeat no-repeat !important;
      background-position: center center !important;
      -webkit-background-size: cover !important;
      background-size: cover !important;
    }

    li {
      width: 200px;
      height: 300px;
      list-style: none;
      background: #fff;
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      //box-shadow: 0 0 2px rgba(0, 0, 0, .2), 1px 1px 1px rgba(0, 0, 0, .2);
      text-align: center;
      font-size: 16px;
      border: 1px solid #ECECEC;
      box-sizing: border-box;
      cursor: default;
    }

  }

</style>



// WEBPACK FOOTER //
// Index.vue?76d01abc